import src from "IMAGE";
export default { src, width: 2576, height: 1094, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAJUlEQVR42m2KQQoAAAjCdP9/dNQpo4EMZNIHRsA4sD1nO+u1QwEIyAAwoRiBswAAAABJRU5ErkJggg==", blurWidth: 8, blurHeight: 3 }
